// removed by extract-text-webpack-plugin
module.exports = {"Container":"Accordion__Container__3g9ui"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Accordion/Accordion.css
// module id = 202
// module chunks = 0